// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__1hSKS","withMobileMargins":"DateRangeInput_withMobileMargins__XTS7d","arrowIcon":"DateRangeInput_arrowIcon__3IAL6"};